<template>
    <div>
        <el-radio-group :value="value" @input="$emit('input',$event)" v-if="options.length>0">
            <el-radio v-for="item in options" :key="item.id" :label="item.id">{{item.name}}</el-radio>
        </el-radio-group>
        <div v-else>请选择院区</div>
    </div>
</template>
<script>
    export default {
        name: "radioType",
        props: {
            value: {
                type: [String, Number,]
            },
            hospital_id: {
                required: true
            },
            size: {
                default: 'small'
            }
        },
        watch: {
            // eslint-disable-next-line no-unused-vars
            hospital_id(newVal) {
                this.getData()
            }
        },
        data() {
            return {
                options: []
            }
        },
        methods: {
            async getData() {
                if (this.hospital_id) {
                    const hl = await this.$http.get(`/mingde/type/?hospital_id=${this.hospital_id}`)
                    this.options = hl.data.data.data || []
                }
            }
        },
        mounted() {
            this.getData()
        }
    };
</script>
<style lang="scss" scoped>
</style>
